import { Controller } from "@hotwired/stimulus"

// Keeps the quantity input within the selected size's available stock.
export default class extends Controller {
  static targets = ["sizeSelect", "quantityInput", "incrementButton", "decrementButton"]

  static values = {
    stock: Object,
    maxQuantity: { type: Number, default: 10 }
  }

  connect() {
    this.updateQuantityOptions()
  }

  updateQuantityOptions() {
    if (!this.hasQuantityInputTarget) return

    const selectedSizeId = this.sizeSelectTargets.find((sizeSelect) => sizeSelect.checked)?.value
    const availableStock = parseInt(this.stockValue?.[selectedSizeId] ?? 0, 10)
    this.quantityLimit = Math.min(Math.max(availableStock || 0, 0), this.maxQuantityValue || 10)
    this.quantityInputTarget.max = this.quantityLimit
    this.quantityInputTarget.disabled = this.quantityLimit < 1
    this.normalizeQuantityInput()
  }

  incrementQuantity(event) {
    event.preventDefault()
    this.setQuantity(this.currentQuantity + 1)
  }

  decrementQuantity(event) {
    event.preventDefault()
    this.setQuantity(this.currentQuantity - 1)
  }

  normalizeQuantityInput() {
    this.setQuantity(this.currentQuantity, { dispatch: false })
  }

  setQuantity(quantity, { dispatch = true } = {}) {
    if (!this.hasQuantityInputTarget) return

    const limit = this.quantityLimit || 1
    const normalizedQuantity = Math.min(Math.max(Number.isFinite(quantity) ? quantity : 1, 1), limit)
    this.quantityInputTarget.value = normalizedQuantity

    if (this.hasIncrementButtonTarget) {
      this.incrementButtonTarget.disabled = normalizedQuantity >= limit
    }

    if (this.hasDecrementButtonTarget) {
      this.decrementButtonTarget.disabled = normalizedQuantity <= 1
    }

    if (dispatch) {
      this.quantityInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.quantityInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  get currentQuantity() {
    const quantity = Number.parseInt(this.quantityInputTarget?.value, 10)
    return Number.isNaN(quantity) ? 1 : quantity
  }
}
